import {
  Component,
  NgModule,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { range } from 'rxjs';
import { SurveyService } from 'src/app/service/Survey/survey.service';

@Component({
  selector: 'app-help',
  templateUrl: 'help.component.html',
  styleUrls: ['./help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpComponent {
  @Input() requestID: any;

  constructor(private surveyService: SurveyService) {}

  /**
   * Handle click event
   */
  onClick(type: string, target: string) {
    this.surveyService
      .referenceClick({ requestID: this.requestID, type, target })
      .subscribe((response: any) => {});
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [HelpComponent],
  exports: [HelpComponent],
})
export class HelpModule {}
